<script>
import TaskCreateButton from '@/components/Task/CreateButton'
import TaskList from '@/components/Task/List/Component'
import { CheckboxComponent } from 'vue-elder-checkbox'
import Card from '@/components/Card-v2'

export default {
  props: {
    reference: Object,
  },
  data() {
    return {
      showDone: false,
    }
  },
  components: {
    TaskCreateButton,
    TaskList,
    CheckboxComponent,
    Card,
  },
}
</script>

<template>
  <Card class="tasks-list-card" v-bind="$attrs">
    <template #header>
      <div class="card-v2__title">{{ $tc('task', 2) }}</div>
      <CheckboxComponent v-model="showDone" :label="$t('showCompleted')" />
      <TaskCreateButton :reference="reference" />
    </template>
    <template #default>
      <TaskList
        :columns="[
          { id: 'title', label: $t('title') },
          { id: 'status', label: $t('status') },
          { id: 'dueAt', label: $t('deadline') },
          { id: 'type', label: $tc('type') },
          { id: 'members', label: $tc('member', 2) },
          { id: 'updatedAt', label: $t('lastUpdated') },
        ]"
        :filter="{
          references: { onModel: reference.onModel, ref: reference.ref, inherit: true },
          status: showDone ? [] : ['!done'],
        }"
        theme="border"
        :select="false"
      />
    </template>
  </Card>
</template>

<style lang="scss">
.tasks-list-card {
  .card-v2__header {
    flex-direction: row;
    gap: 1rem;
  }
  .card-v2__title {
    margin-right: auto;
  }

  .elder-checkbox {
    align-self: center;
  }
}
</style>
